import { render, staticRenderFns } from "./NoviTinyMce.vue?vue&type=template&id=00b3541e&"
import script from "./NoviTinyMceVue.ts?vue&type=script&lang=ts&"
export * from "./NoviTinyMceVue.ts?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports